import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { IEventV2 } from '../../../../../../data/entities/event';
import { FormLabel, FormSelect } from '../../../../../components/form';
import { Paragraph } from '../../../../../components/paragraph/Paragraph';

interface ISetCurrencyModalProps {
	event: IEventV2;
	onRequestClose: () => any;
	sendCurrency: (propertyId: string, eventId: string, rentalsunitedBookingId?: string, currency?: string) => any;
}

export const SetCurrencyModal: React.FC<ISetCurrencyModalProps> = (props) => {
	const { event, sendCurrency, onRequestClose } = props;
	const [currency, setCurrency] = React.useState('XTS');

	const onSave = async () => {
		await sendCurrency(event.id, event.property_id, props.event.booking?.external_id?.[0]?.id, currency);
		onRequestClose();
	};

	return <Modal
		title="Set currency"
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id="booking_set_currency_save"
				onClick={onSave}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
			>
				Save
			</Button>}
	>
		<div className="booking_currency_set_content">
			<Paragraph>Please enter the currency for this booking.</Paragraph>
			<Paragraph>The currency must be in ISO format GBP, USD, EUR.</Paragraph>
			<FormLabel htmlFor="booking_currency_set--currency">Currency</FormLabel>
			<FormSelect id="booking_currency_set--currency" defaultValue={currency} onChange={(e) => setCurrency(e.target.value)}>
				<option value="XTS">XTS</option>
				<option value="GBP">GBP</option>
				<option value="USD">USD</option>
				<option value="EUR">EUR</option>
			</FormSelect>
		</div>
	</Modal>;
};
